import React from 'react'
import { Result, Button } from 'antd'

import './index.css'
import { Link } from 'react-router-dom'

function ErrorPage(props) {
  sessionStorage.removeItem('containerInfos_unchoice')
  return (
    <div>
      <Result
        status="404"
        title="Oops! Page Not Found"
        extra={
        <Link to='/'>
          <Button icon='close' type='primary' key='console'>
            Close
          </Button>
        </Link>
        }
      />
    </div>
  )
}

export default ErrorPage
